module.exports = "a {\n  color: #000000;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/faq/faq.component.css
// module id = ./src/app/components/faq/faq.component.css
// module chunks = main